export const ValidationRulesMixin = {
    methods: {
        notNullNorEmpty(value) {
            return value !== '' && value !== null || 'Ne doit pas être vide';
        }
    }
}